export default __webpack_public_path__ + "static/media/crv.df1660a3.svg";